import React,{useEffect,useState} from 'react'
import { useLocation } from "react-router-dom";
import { getDocs,doc ,collection} from 'firebase/firestore';
import { db } from '../../firebase';
import Img from "../../svg/userimg.png";
import Industrynav from './Industrynav';
export default function Viewstudetails() {
    const location = useLocation();
    const { stuid } = location.state;
    // const [user,setUser] = useState();
    const [joblist, setJoblist] = useState([]);

  const ref = collection(db, "users");
  
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  return (
    <>
    <Industrynav/>
    {joblist.map((user)=>{
        return (user.uid==stuid)?
        <section class="section about-section gray-bg " id="about">
        <div class="container">
            <div class="row align-items-center flex-row-reverse">
            {/* <img src={user.avatar || Img} alt="avatar" className='avatar' /> */}
           
           
                <div class="col-lg-6">
                    <div class="about-text go-to">
                  
                        <h1 class="dark-color"><mark>{user.name}</mark></h1>
                        <h4 class="dark-color">About Me</h4>
                        <h6 class=" lead">{user.aboutme}</h6>
                        <div class="row about-list">
                                     <div class="col-md-6">
                                     <div class="media">
                                    <label className="ctext">Email : </label>
                                    <p className="ctext">{user.email}</p>
                                </div>
                                <div class="media">
                                    <label className="ctext">CGPA : </label>
                                    <p className="ctext">{user.cgpa}</p>
                                </div>
                                         <div class="media">
                                    <label className="ctext">Location:  </label>
                                    <p>&nbsp;&nbsp;</p>
                                    <p className="ctext"> {user.address}</p>
                                </div>
                                <div class="media">
                                    <label className="ctext">MIS Id :  </label>
                                    <p className="ctext"> {user.misid}</p>
                                </div>
                                           <div class="media">
                                    <label className="ctext">Department:</label>
                                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                                    <p className="ctext">&nbsp;&nbsp;{user.department}</p>
                                </div>
                                     </div>
                                     <div class="col-md-6">
                                     <div class="media">
                                    <label className="ctext">Class :  </label>
                                    <p className="ctext"> {user.classes}</p>
                                </div>
                                {/* <div class="media">
                                    <label className="ctext">Division :  </label>
                                    <p className="ctext"> {user.division}</p>
                                </div> */}
                                <div class="media">
                                    <label className="ctext">Contact :  </label>
                                    <p className="ctext"> {user.contact}</p>
                                </div>
                                <div class="media">
                               <label className="ctext">Roll no. :  </label>
                               <p className="ctext"> {user.roll}</p>
                           </div>
                                        
                                     </div>
                                 </div>
                             
                         
                      
                        
                    </div>
                </div>
                 <div className="profile_container col-lg-6">
             <div className='img_containers'>
              <img src={user.avatar || Img} alt="avatar" className='avatar'/>
             </div>
             </div>
            </div>
           
        </div>
     </section>
        :null
    })}
    
    </>
  )
}
